import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { Colors, ScreenWidth, ZIndex } from 'web-common/src/shared/styles';
import { NAV_BAR_MOBILE_SPACING, NAV_BAR_SPACING } from '../styles';

export const RightNavContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
  z-index: ${ZIndex.ConsumerNavBar};
  gap: ${NAV_BAR_MOBILE_SPACING};
  padding-left: ${NAV_BAR_MOBILE_SPACING};

  ${minScreen(ScreenWidth.SMALL)} {
    gap: ${NAV_BAR_SPACING};
    padding-left: ${NAV_BAR_SPACING};
  }
`;

export const NavItemIcon = styled.div`
  position: relative;
  align-items: center;
  color: ${Colors.GRAY_DARK_20};
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 36px;
  width: 36px;
`;

export const UnreadIndicator = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;
  background: ${Colors.RADISH};
  border-radius: 100%;
  width: 8px;
  height: 8px;

  ${minScreen(ScreenWidth.SMALL)} {
    top: 0;
    right: 0;
  }
`;
